module.exports = __webpack_public_path__ + "static/media/bg-card-vip.dbd426bc.png";